import React from "react";
import mock01 from '../assets/images/mock01.png';
import mock02 from '../assets/images/mock02.png';
import mock03 from '../assets/images/mock03.png';
import mock04 from '../assets/images/mock04.png';
import mock05 from '../assets/images/mock05.png';
import mock06 from '../assets/images/mock06.png';
import mock07 from '../assets/images/mock07.png';
import mock08 from '../assets/images/mock08.png';
import mock09 from '../assets/images/mock09.png';
import mock10 from '../assets/images/mock10.png';
import '../assets/styles/Project.scss';

function Project() {
    return(
    <div className="projects-container" id="projects">
        <h1>CALLER-G Projects</h1>
        <div className="projects-grid">
            <div className="project">
                <a href="https://t.me/CRYPTOGCALL/27" target="_blank" rel="noreferrer"><img src={mock10} className="zoom" alt="thumbnail" width="100%"/></a>
                <a href="https://t.me/CRYPTOGCALL/27" target="_blank" rel="noreferrer"><h2>$FPEPE</h2></a>
            </div>
            <div className="project">
                <a href="https://t.me/CRYPTOGCALL/26" target="_blank" rel="noreferrer"><img src={mock09} className="zoom" alt="thumbnail" width="100%"/></a>
                <a href="https://t.me/CRYPTOGCALL/26" target="_blank" rel="noreferrer"><h2>$vfNa</h2></a>
            </div>
            <div className="project">
                <a href="https://t.me/CRYPTOGCALL/25" target="_blank" rel="noreferrer"><img src={mock08} className="zoom" alt="thumbnail" width="100%"/></a>
                <a href="https://t.me/CRYPTOGCALL/25" target="_blank" rel="noreferrer"><h2>$YEE</h2></a>
            </div>
            <div className="project">
                <a href="https://t.me/CRYPTOGCALL/24" target="_blank" rel="noreferrer"><img src={mock07} className="zoom" alt="thumbnail" width="100%"/></a>
                <a href="https://t.me/CRYPTOGCALL/24" target="_blank" rel="noreferrer"><h2>$JAKO</h2></a>
            </div>
            <div className="project">
                <a href="https://t.me/CRYPTOGCALL/22" target="_blank" rel="noreferrer"><img src={mock06} className="zoom" alt="thumbnail" width="100%"/></a>
                <a href="https://t.me/CRYPTOGCALL/22" target="_blank" rel="noreferrer"><h2>$Yarl</h2></a>
            </div>
            <div className="project">
                <a href="https://t.me/CRYPTOGCALL/21" target="_blank" rel="noreferrer"><img src={mock05} className="zoom" alt="thumbnail" width="100%"/></a>
                <a href="https://t.me/CRYPTOGCALL/21" target="_blank" rel="noreferrer"><h2>$AHAB</h2></a>
            </div>
            <div className="project">
                <a href="https://t.me/CRYPTOGCALL/20" target="_blank" rel="noreferrer"><img src={mock04} className="zoom" alt="thumbnail" width="100%"/></a>
                <a href="https://t.me/CRYPTOGCALL/20" target="_blank" rel="noreferrer"><h2>$White Shark</h2></a>
            </div>
            <div className="project">
                <a href="https://t.me/CRYPTOGCALL/19" target="_blank" rel="noreferrer"><img src={mock03} className="zoom" alt="thumbnail" width="100%"/></a>
                <a href="https://t.me/CRYPTOGCALL/19" target="_blank" rel="noreferrer"><h2>$WHALE</h2></a>
            </div>
            <div className="project">
                <a href="https://t.me/CRYPTOGCALL/18" target="_blank" rel="noreferrer"><img src={mock02} className="zoom" alt="thumbnail" width="100%"/></a>
                <a href="https://t.me/CRYPTOGCALL/18" target="_blank" rel="noreferrer"><h2>$WORKIE</h2></a>
            </div>
            <div className="project">
                <a href="https://t.me/CRYPTOGCALL/16" target="_blank" rel="noreferrer"><img src={mock01} className="zoom" alt="thumbnail" width="100%"/></a>
                <a href="https://t.me/CRYPTOGCALL/16" target="_blank" rel="noreferrer"><h2>$SHREK</h2></a>
            </div>
        </div>
    </div>
    );
}

export default Project;